var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"arena-wrapper"},[_c('div',{staticClass:"three-bg"},[_c('TechTray',{attrs:{"data":_vm.screenData.trayData}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }